<template>
  <div class="tw:rounded-lg tw:border tw:bg-white"
       :class="conditions.length === 0 ? 'tw:border-dashed tw:border-zinc-400' : 'tw:border-zinc-300'">
    <div data-anchor class="tw:flex tw:items-center tw:gap-2 tw:px-2.5 tw:py-2 tw:text-sm tw:font-medium"
         :class="conditions.length === 0 ? 'tw:text-zinc-500' : 'tw:text-zinc-900'">
      <span class="tw:flex tw:size-5.5 tw:shrink-0 tw:items-center tw:justify-center" aria-hidden="true">
        <span class="tw:size-3.5 tw:rotate-45 tw:rounded-[3px]"
              :class="conditions.length === 0 ? 'tw:border-[1.5px] tw:border-zinc-400' : 'tw:bg-amber-500'"></span>
      </span>
      {{ conditions.length === 0 ? $t('Every participant') : $t('Conditions') }}
    </div>
    <dl v-if="conditions.length" class="tw:m-0 tw:border-t tw:border-zinc-200 tw:px-2.5 tw:py-1.5 tw:text-xs tw:leading-6 tw:text-zinc-500">
      <template v-for="(group, groupIndex) in conditions" :key="groupIndex">
        <div v-if="groupIndex > 0" class="tw:my-1 tw:flex tw:items-center tw:gap-2 tw:text-zinc-400" role="separator">
          <span class="tw:h-px tw:flex-1 tw:bg-zinc-200"></span>{{ $t('or') }}<span class="tw:h-px tw:flex-1 tw:bg-zinc-200"></span>
        </div>
        <div v-for="(condition, index) in group" :key="index" class="tw:flex tw:justify-between tw:gap-3">
          <dt class="tw:font-normal">{{ condition.label }}</dt>
          <dd v-if="condition.value" class="tw:m-0 tw:text-right tw:text-zinc-900">{{ condition.value }}</dd>
        </div>
      </template>
    </dl>
  </div>
</template>

<script setup lang="ts">
import type { BoardCondition } from './types'

/**
 * The targeting a message applies, drawn like the message it leads to: a line per filter, the
 * groups apart, any group being enough. No condition means every participant of the trigger.
 */
defineProps<{
  conditions: BoardCondition[][];
}>()
</script>
